import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { DataService } from './services/data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  private _router: Subscription;

  constructor(private router: Router, private dataService: DataService) {}

  ngOnInit() {
    /* const publicRoutes = ['/pages/login', '/pages/register', '/forgotPassword'];
    const currentUrl = this.router.url; */

    /* if (!sessionStorage.getItem('token')) {
      this.router.navigate(['/pages/login']);
    } */
    /* if (
      !sessionStorage.getItem('token') &&
      !publicRoutes.includes(currentUrl)
    ) {
      this.router.navigate(['/pages/login']);
      return;
    } */
    this._router = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const body = document.getElementsByTagName('body')[0];
        const modalBackdrop =
          document.getElementsByClassName('modal-backdrop')[0];
        if (body.classList.contains('modal-open')) {
          body.classList.remove('modal-open');
          modalBackdrop.remove();
        }
      });

    /* const token = sessionStorage.getItem('token');
    if (!token || this.dataService.isTokenExpired(token)) {
      sessionStorage.clear();
      
      if (!publicRoutes.includes(currentUrl)) {
        this.router.navigateByUrl('/pages/login');
      }
      return;
    } */
  }
}
